<template>
  <div class="lottery-wrap" v-if="prizesList">
    <Modal v-model="lotteryModal" v-bind="modelBase" class="lottery-modal">
      <img v-if="prizeRes.is_lucky !== 0" src="//res.aidalan.com/hd/sg/img/lotteryPrize.png">
      <img v-if="prizeRes.is_lucky === 0" src="//res.aidalan.com/hd/sg/img/noPrize.png">
      <div v-if="prizeRes.is_lucky !== 0" class="prize-text">
        <p>{{prizeRes.good_name}}</p>
        <span>{{prizeRes.code}}</span>
      </div>
      <div v-if="prizeRes.is_lucky === 0" class="no-prize-text">
        <p>{{prizeRes.good_name}}
          <b v-if="prizeRes.tipsB">{{prizeRes.tipsB[0].replace(/\*\*/g, '')}}</b></p>
      </div>
    </Modal>
    <Modal v-model="wxModal" v-bind="modelBase" class="lottery-modal">
      <img src="//res.aidalan.com/hd/jzx/img/wxtips.jpg">
      <div class="no-prize-text no-wx-text">
        <p>您离大奖只有一步之遥！<br/>
        搜索关注微信公众号【黑马手游】<br/>
        点击【活动福利】-【三国中秋抽奖】即可参与哦～</p>
      </div>
    </Modal>
    <Modal v-model="detailModal" v-bind="modelBase" class="detail-modal">
      <img v-if="detailModal" :src="detailImg">
    </Modal>
    <Row>
      <i-col span="8" class="prize-col" v-for="(item, index) in lis1" :key="index">
        <div @click="showDetail(item)">
          <img :src="resPublic+'/a/'+item.pic_url" :alt="item.goods_name">
          <span v-if="activeClass[item.index]" class="active"></span>
        </div>
      </i-col>
    </Row>
    <Row>
      <i-col span="8" class="prize-col">
        <div @click="showDetail(prizesList[3])">
          <img :src="resPublic+'/a/'+prizesList[3].pic_url" :alt="prizesList[3].goods_name">
          <span v-if="activeClass[prizesList[3].index]" class="active"></span>
        </div>
      </i-col>
      <i-col span="8" class="prize-col">
        <div class="prize-go-btn" @click="startLottery">
          <img :src="resPublic+'/a/'+prizesList[4].pic_url" :alt="prizesList[4].goods_name">
        </div>
      </i-col>
      <i-col span="8" class="prize-col">
        <div @click="showDetail(prizesList[5])">
          <img :src="resPublic+'/a/'+prizesList[5].pic_url" :alt="prizesList[5].goods_name">
          <span v-if="activeClass[prizesList[5].index]" class="active"></span>
        </div>
      </i-col>
    </Row>
    <Row>
      <i-col span="8" class="prize-col" v-for="(item, index) in lis2" :key="index">
        <div @click="showDetail(item)">
          <img :src="resPublic+'/a/'+item.pic_url" :alt="item.goods_name">
          <span v-if="activeClass[item.index]" class="active"></span>
        </div>
      </i-col>
    </Row>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      resPublic: '//res.aidalan.com/hd/img/sg',
      activeClass: [false, false, false, false, false, false, false, false],
      index: -1,
      count: 8,
      timer: null,
      timerErr: null,
      times: 0,
      speedData: 100,
      lock: false,
      afterLotteryHandler: null,
      prize: 0,
      prizesList: null,
      lotteryModal: false,
      modelBase: {
        'footer-hide': true,
        closable: false,
      },
      detailModal: false,
      wxModal: false,
      detailImg: '',
      prizeRes: {},
    };
  },
  computed: {
    lis1() {
      return this.prizesList.slice(0, 3);
    },
    lis2() {
      return this.prizesList.slice(6, 9);
    },
    ...mapState({
      userInfo: state => state.login.userInfo,
      isLogin: state => state.login.isLogin,
    }),
  },
  props: {
    cycle: {
      type: Number,
      default: 20,
    },
    speed: {
      type: Number,
      default: 0,
    },
  },
  created() {
    this.setPrizesList();
  },
  methods: {
    async setPrizesList() {
      const res = await axios.post('/api/lotteryGoodsList', {
        f_id: 1,
      });
      if (res.data.ret === 1) {
        const ids = [0, 1, 2, 7, -1, 3, 6, 5, 4];
        const { content } = res.data;
        content.forEach((item, index) => {
          const oItem = item;
          oItem.index = ids[index];
        });
        this.prizesList = content;
      }
    },
    async startLottery() {
      const isWx = /MicroMessenger/i.test(navigator.userAgent.toLowerCase());
      if (!isWx || !this.userInfo || this.userInfo.subscribe === 0) {
        this.wxModal = true;
      } else if (!this.lock) {
        this.lock = true;
        this.roll();
        const res = await axios.post('/api/lottery', {
          access_token: this.userInfo.access_token,
          openid: this.userInfo.openid,
          user_id: this.userInfo.union_user_id,
          user_account: this.userInfo.union_user_account,
          f_id: 1,
        }).catch(() => {
          clearTimeout(this.timer);
          this.endRoll();
          this.activeClass = [false, false, false, false, false, false, false, false];
          this.$Message.error('网络异常，请检查网络！');
        });
        const { ret, content } = res.data;
        if (ret === 1) {
          this.prizeRes = content;
          this.prizesList.forEach((item) => {
            if (item.position === content.position) {
              this.prize = item.index;
            }
          });
        } else if (ret === 0) {
          this.prizeRes = {
            is_lucky: 0,
            ret: 0,
            good_name: res.data.msg.replace(/\*\*.+\*\*/g, ''),
            tipsB: res.data.msg.match(/\*\*.+\*\*/g),
            subscribe: content.subscribe,
          };
          this.endRoll();
        }
      }
    },
    rollHandler() {
      let index = this.index;
      const count = this.count;

      this.activeClass = [false, false, false, false, false, false, false, false];
      index += 1;
      if (index > count - 1) {
        index = 0;
      }
      this.activeClass[index] = true;
      this.index = index;
      return false;
    },
    roll() {
      clearTimeout(this.timer);
      this.activeClass = [false, false, false, false, false, false, false, false];
      this.times += 1;
      this.rollHandler();
      if (this.prizeRes.is_lucky === undefined) {
        this.timer = setTimeout(this.roll, this.speedData);
        return;
      }
      if (this.times > this.cycle + 10 && this.prize === this.index) {
        this.endRoll();
      } else {
        if (this.times < this.cycle) {
          this.speedData -= 2;
        } else if (this.times > this.cycle + 10 &&
          ((this.prize === 0 && this.index === 7) || this.prize === this.index + 1)) {
          this.speedData += 110;
        } else {
          this.speedData += 20;
        }
        if (this.speedData < 40) {
          this.speedData = 40;
        }
        this.timer = setTimeout(this.roll, this.speedData);
      }
    },
    endRoll() {
      clearTimeout(this.timer);
      this.lock = false;
      this.index = -1;
      this.count = 8;
      this.timer = null;
      this.speedData = this.speed;
      this.times = 0;
      if (this.prizeRes.is_lucky === 1) {
        setTimeout(this.showResult, 1000);
      } else if (this.prizeRes.is_lucky === 0) {
        if (this.prizeRes.subscribe === 0) {
          this.activeClass = [false, false, false, false, false, false, false, false];
          this.wxModal = true;
          return;
        }
        if (this.prizeRes.ret === 0) {
          this.activeClass = [false, false, false, false, false, false, false, false];
          this.showResult();
          return;
        }
        setTimeout(this.showResult, 1000);
      }
    },
    showResult() {
      this.lotteryModal = true;
    },
    showDetail(o) {
      if (o.position === 8) {
        return;
      }
      window.trackEvent(['_trackEvent', o.goods_name, '点击']);
      this.detailModal = true;
      this.detailImg = `${this.resPublic}/b/${o.pic_url}?v=3`;
    },
  },
};
</script>

<style>
.lottery-wrap{
  padding: .94vw;
  border: 1px solid #1c021e;
  background-color: #39053C;
}
.lottery-wrap img{
  width: 100%;
  display: block;
}
.prize-col{
  padding: .94vw;
}
@media (min-width: 640px) {
  .lottery-wrap, .prize-col{
    padding: 11px;
  }
}
.prize-col>div{
  position: relative;
}
.prize-go-btn{
  cursor: pointer;
}
.prize-col .active{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  box-shadow: 0 0 20px #0f0 inset;
}
.lottery-modal img, .detail-modal img{
  display: block;
  width: 100%;
}
.lottery-modal .ivu-modal-body, .detail-modal .ivu-modal-body{
  padding: 0;
  position: relative;
}
.prize-text, .no-prize-text {
  width: 100%;
  position: absolute;
  top: 62vw;
}
.no-wx-text{
  width: 100%;
  position: absolute;
  top: 70vw;
}
.prize-text p{
  font-size: 6vw;
  color: #ea0600;
  text-align: center;
}
.no-prize-text p{
  font-size: 5vw;
  color: #535252;
  text-align: center;
}
.no-prize-text b{
  font-size: 4vw;
  display: block;
}
.no-wx-text p{
  font-size: 4vw;
  color: #535252;
  text-align: center;
}
.prize-text span{
  display: block;
  text-align: center;
  font-size: 4vw;
  color: #535252;
  text-align: center;
}
@media (min-width: 640px) {
  .prize-text, .no-prize-text{
    top: 346px;
  }
  .no-wx-text{
    top: 388px;
  }
  .prize-text p{
    font-size: 32px;
  }
  .prize-text span{
    font-size: 20px;
  }
  .no-prize-text p{
    font-size: 30px;
  }
  .no-wx-text p{
    font-size: 20px;
  }
  .no-prize-text b{
    font-size: 26px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Lottery.vue